import React from "react";
import BecomeBanner from "../components/BecomePartner/BecomeBanner";
import WhyPartnerWithAcross from "../components/BecomePartner/WhyPartnerWithAcross";
import DiscoveryCategory from "../components/BecomePartner/DiscoveryCategory";
import BecomePartnerIllustration from "../assets/Graphics/BecomePartnerOne.png";
import PartnerWithUs from "../components/BecomePartner/PartnerWithUs";

import banner1 from "../assets/Banner/WebBanner/b2.png";
import Header from "../layout/Header";

import "../components/BecomePartner/styles.css";
import { Typography } from "@mui/material";
import Form from "../components/ContactUs/Form";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";

const ONBOARD_LIST = [
  {
    id: 1,
    title: "Submit an Inquiry",
    descp: "Let us know your interest by filling out the quick form below.",
  },
  {
    id: 2,
    title: "Discussion & Proposal",
    descp: "Our partnerships team will connect with you to explore synergies.",
  },
  {
    id: 3,
    title: "Agreement & Activation",
    descp:
      "Once aligned, we’ll finalize the partnership terms and activate your service suite.",
  },
];

const BecomePartner = () => {
  return (
    <>
      <HeroSection
        bannerImage={banner1}
        heading=" Become a Partner"
        description="  Partner with Across Assist to expand your impact, innovate
                  your services, and help shape the future of emergency response
                  and assurance."
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      />
      

      <div className="container mx-auto max-w-2xl text-center my-8">
        <h4 className="font-semibold text-[2.1rem] mb-4">
          Together, We Create Impact
        </h4>
        <p className="text-[1.12rem]">
          Partner with Across Assist, to unlock new growth opportunities,
          enhance your service offerings, and deliver industry-first solutions
          in emergency response and assurance.
        </p>
      </div>

      <div>
        <WhyPartnerWithAcross />
      </div>

      <div>
        <DiscoveryCategory />
      </div>
      <section
        className="w-full bg-[#fff6f1] py-8 px-4"
        aria-label="How we onboard"
      >
        <div className="max-w-screen-lg mx-auto">
          <div className="text-center mb-6">
            <h2 className="text-2xl md:text-3xl font-semibold">
              How we Onboard
            </h2>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8 How-we-Onboard">
            <div className="w-full md:w-5/12 flex justify-center">
              <img
                src={BecomePartnerIllustration}
                alt="Handshake illustration"
                className="w-full max-w-[320px] md:max-w-[360px] object-contain"
              />
            </div>

            <div className="w-full md:w-7/12">
              <ul className="flex flex-col gap-3">
                {ONBOARD_LIST.map((step) => (
                  <li key={step.id} className="flex items-start mb-8 gap-4">
                    <span className="mt-1 mr-3 inline-flex h-6 w-6 items-center justify-center rounded-full bg-green-600 text-white text-xs font-semibold">
                      {step.id}
                    </span>
                    <div>
                      <Typography
                        variant="h5"
                        className="text-sm md:text-base font-semibold"
                        sx={{
                          fontSize: {
                            xs: "1rem",
                            sm: "1.12rem",
                            md: "1.18rem",
                            lg: "1.198rem",
                          },
                        }}
                      >
                        {step.title}
                      </Typography>
                      <p className="mt-1 text-sm md:text-base text-gray-700">
                        {step.descp}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-screen-xl mx-auto flex justify-center  py-6 my-8">
        <div className="w-full md:w-6/12 flex justify-center">
          <Form />
        </div>
      </div>
      {/* <PartnerWithUs /> */}
    </>
  );
};

export default BecomePartner;
